// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react'

// mobx
import { observer } from 'mobx-react'

// fragments
import { fragments } from 'services/get-fragments'

// semantic-ui
import { Header, Segment, Container } from 'semantic-ui-react'

export const HomePage = observer(() => (
  <React.Fragment>
    <Segment vertical textAlign='center' className="home-hero">
      <Header as='h1'>{fragments.Home.header}</Header>
      <p>{fragments.Home.tagline}</p>
    </Segment>
    <Segment vertical style={{ padding: "40px 0px", margin: "0 !important" }}>
      <Container fluid text textAlign='justified'>
        <fragments.Home.jsx />
      </Container>
    </Segment>
  </React.Fragment>
))

export default HomePage
